import { useNavigate } from "react-router-dom";
import { PACKAGES } from "../../data/content";
import { SectionHeading, GhostButton } from "../primitives";
import PackageCard from "../PackageCard";

export default function PackagesPreview() {
  const navigate = useNavigate();
  return (
    <section data-testid="packages-preview" className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <SectionHeading
          eyebrow="Website Packages"
          title="Clear pricing, no surprises"
          sub="Fixed-price website packages designed for Canadian small businesses — pick the one that fits where you are today."
        />
        <GhostButton to="/packages" className="hidden shrink-0 md:inline-flex" data-testid="packages-view-all">
          Compare all packages
        </GhostButton>
      </div>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {PACKAGES.map((pkg, i) => (
          <PackageCard
            key={pkg.id}
            pkg={pkg}
            index={i}
            ctaLabel={pkg.custom ? "Get a Quote" : "View Details"}
            onCta={() => navigate("/packages")}
          />
        ))}
      </div>
    </section>
  );
}
